import React, { useEffect, useState } from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
import { ArrowForward } from '@mui/icons-material';
export const CgmStatusTimelineListItem = (props) => {
    const { timelineActivity } = props;
    // default text color and background color to "Need Data" and update it for opt in / opt out
    const [textColorPreviousState, setTextColorPreviousState] = useState('#D32F2F');
    const [backgroundColorPreviousState, setBackgroundColorPreviousState] = useState('#FBEBEB');
    const [textColorNewState, setTextColorNewState] = useState('#D32F2F');
    const [backgroundColorNewState, setBackgroundColorNewState] = useState('#FBEBEB');
    useEffect(() => {
        if (timelineActivity.previousState === 'Ready') {
            setTextColorPreviousState('#42A5F5');
            setBackgroundColorPreviousState('#42A5F51A');
        }
        if (timelineActivity.previousState === 'Waiting') {
            setTextColorPreviousState('#34A5C5');
            setBackgroundColorPreviousState('#34A5C51A');
        }
        if (timelineActivity.previousState === 'Completed') {
            setTextColorPreviousState('#4CAF50');
            setBackgroundColorPreviousState('#EEF7EE');
        }
        if (timelineActivity.newState === 'Ready') {
            setTextColorNewState('#42A5F5');
            setBackgroundColorNewState('#42A5F51A');
        }
        if (timelineActivity.newState === 'Waiting') {
            setTextColorNewState('#34A5C5');
            setBackgroundColorNewState('#34A5C51A');
        }
        if (timelineActivity.newState === 'Completed') {
            setTextColorNewState('#4CAF50');
            setBackgroundColorNewState('#EEF7EE');
        }
    });
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: 'STATUS', value: timelineActivity.previousState ?? '', backgroundColor: backgroundColorPreviousState, textColor: textColorPreviousState, showPhoneIcon: false, crossOut: false }),
            React.createElement(ArrowForward, { style: { marginRight: '10px' } }),
            React.createElement(TimelineListItemInfoChip, { label: 'STATUS', value: timelineActivity.newState ?? '', backgroundColor: backgroundColorNewState, textColor: textColorNewState, showPhoneIcon: false, crossOut: false }))));
};
